import React from 'react';
import PropTypes from 'prop-types';
// import groupBy from 'lodash/groupBy';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import DialogForm from 'shared/components/DialogForm/DialogForm';

import s from './AdvertMessage.css';

const isMobile = __APP__ === 'mobile';

class AdvertMessage extends React.Component {
  static propTypes = {
    carInfo: PropTypes.shape().isRequired,
    user: PropTypes.shape().isRequired,
    handleSendMessage: PropTypes.func.isRequired,
    //
    intl: intlShape.isRequired,
  };
  render() {
    const { intl, carInfo, user, handleSendMessage } = this.props;
    const userId = user && user.user && user.user.id;
    const isMyAdvert = false; // +carInfo.author.id === +userId;
    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClass}>
        {!isMyAdvert &&
          <div>
            <div className={s.messageTitle}>
              {intl.formatMessage({ id: 'Оставить сообщение владельцу' })}
            </div>
            <DialogForm
              onSubmit={textareaMsg => handleSendMessage(textareaMsg, carInfo.id)}
              customStyle={s.dialogForm}
            >
              {!(carInfo.agency.is_official || carInfo.author.id === userId) &&
                <span className={s.warningBlock}>
                  <FormattedMessage id="Ввиду наличия на рынке мошеннических схем ни в коем случае не проводите полную или частичную оплату без проверки продавца" />
                </span>}
            </DialogForm>
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(AdvertMessage));



// WEBPACK FOOTER //
// ./src/shared/components/AdvertMessage/AdvertMessage.js